import React from "react"
import { Box, IconButton, Typography } from "@mui/material"
import { Close as CloseIcon } from "@mui/icons-material"

const FilePreview = ({ file, onRemove }) => {
  const isImage = file.type.startsWith("image/")
  const isVideo = file.type.startsWith("video/")
  const isAudio = file.type.startsWith("audio/")

  return (
    <Box
      sx={{
        position: "relative",
        width: 100,
        height: 100,
        border: "1px solid #ccc",
        borderRadius: 1,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isImage && (
        <img
          src={URL.createObjectURL(file) || "/placeholder.svg"}
          alt={file.name}
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover" }}
        />
      )}
      {isVideo && (
        <video src={URL.createObjectURL(file)} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover" }} />
      )}
      {isAudio && <audio src={URL.createObjectURL(file)} controls style={{ maxWidth: "100%" }} />}
      {!isImage && !isVideo && !isAudio && (
        <Typography variant="body2" align="center">
          {file.name}
        </Typography>
      )}
      <IconButton
        size="small"
        onClick={onRemove}
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          bgcolor: "rgba(255, 255, 255, 0.7)",
          "&:hover": {
            bgcolor: "rgba(255, 255, 255, 0.9)",
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}

export default FilePreview

